import React, { Component, RefObject, SyntheticEvent } from 'react';

import './SofaFormAddressWrapper.scss';

import AddressEditor, { AddressEditorModes, AddressEditorType } from 'components/AddressEditor/AddressEditor';
import { generateRandomId } from 'helpers';
import { AddressModel, IfcAddressDescription, areAddressesEqual } from 'models';
import { PropertyValueType, addressToIlpAddress, ilpAddressToAddress } from 'helpers/dynamicFormHelpers';
import { SofaFormControl } from '@sofology/sofologycomponents';

interface OwnProps {
    label: string;
    ifcAddressQuestionSet: IfcAddressDescription;
    globalState: any;
    parentControl: any;
    onChange: (e: any) => void;
    onBlur: (e: SyntheticEvent) => void;
    value: string;
    helperText: string | null;
    addErrorClass: boolean;
    ref: RefObject<any> | undefined;
    helperTextType?: 'error' | 'info';
    name: string;
    readonly?: boolean;
    gtmFormName: string;
    index: number;
}

interface OwnState {
    addressFormId: string;
    prevAddress: AddressModel | null;
    currentAddress: AddressModel | null;
    originalParentControlValidateFunc: () => Promise<SofaFormControl<any>>;
}

export class SofaFormAddressWrapper extends Component<OwnProps, OwnState> {
    private element = React.createRef<HTMLDivElement>();
    private addressEditor = React.createRef<AddressEditorType>();
    constructor(props: OwnProps) {
        super(props);
        this.state = {
            addressFormId: generateRandomId(),
            prevAddress: null,
            currentAddress: null,
            originalParentControlValidateFunc: this.props.parentControl.validate
        };

        this.mountParentControlValidateFunc();
    }

    componentWillUnmount(): void {
        this.unmountParentControlValidateFunc();
    }

    handleOnAddressChange = (addressComponentMode: AddressEditorModes, address: AddressModel) => {
        if (!areAddressesEqual(this.state.prevAddress, address)) {
            this.setState({ prevAddress: this.state.currentAddress, currentAddress: address });
            const ilpAddress = addressToIlpAddress(address, this.props.ifcAddressQuestionSet);
            this.props.onChange({ target: { value: ilpAddress } });
        }
    };

    render(): JSX.Element {
        const { readonly, value } = this.props;

        const address = ilpAddressToAddress(value, this.props.ifcAddressQuestionSet);
        const defaultAddress = address.isEmptyAddress() ? null : address;

        return (
            <div key={this.props.name} className='sofa-form-address-wrapper' ref={this.element}>
                <div className='sofa-form-address-wrapper__label'>{this.props.label}</div>
                <AddressEditor
                    startControlIndex={this.props.index + 1}
                    defaultAddress={defaultAddress}
                    readonlyAddress={readonly ? address : undefined}
                    ifcAddressQuestionSet={this.props.ifcAddressQuestionSet}
                    gtmFormName={this.props.gtmFormName}
                    addressFormId={this.state.addressFormId}
                    ref={this.addressEditor}
                    onChange={this.handleOnAddressChange}
                />
            </div>
        );
    }

    private mountParentControlValidateFunc() {
        const originalParentControlValidateFunc = this.props.parentControl.validate;
        this.props.parentControl.validate = () => {
            return this.addressEditor.current!.validate().then(invalidControls => {
                if (invalidControls.length === 0) {
                    return originalParentControlValidateFunc();
                }

                return this.props.parentControl;
            });
        };
    }

    private unmountParentControlValidateFunc() {
        this.props.parentControl.validate = this.state.originalParentControlValidateFunc;
    }

    getFormData(): Record<string, PropertyValueType> {
        return addressToIlpAddress(this.addressEditor.current!.getFormData(), this.props.ifcAddressQuestionSet);
    }
}
